import React from 'react'
import PropTypes from 'prop-types'
import { MobileSidebar } from '../../core'
import MobileMenuButton from './MobileMenuButton'
import MobileMenuContent from './MobileMenuContent'

/**
* Mobile menu component.
*
* Wrapper component that includes the toggle button and sidebar for a mobile
* specific menu. Handles state of when the sidebar is open and when it is closed.
*/
class MobileMenu extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      open: false,
    }

    this.toggleMenu = this.toggleMenu.bind(this)
    this.checkVisibility = this.checkVisibility.bind(this)
  }

  /**
  * Toggles the sidebar's state. Passed down to children components. Also adds
  * and removes a the visibility event listener to know when the state should
  * be switched to closed once the screen gets too large for the mobile menu.
  */
  toggleMenu(source) {
    // Add or remove the visiblity checker before setting the new state.
    if (this.state.open) {
      window.removeEventListener('resize', this.checkVisibility)
      $.track('event', 'Mobile Menu', 'Close', source)
    } else {
      window.addEventListener('resize', this.checkVisibility)
      $.track('event', 'Mobile Menu', 'Open', source)
    }

    this.setState({ open: !this.state.open })
  }

  /**
  * Window Resize Event Handler. Checks to see if the window is resized to
  * larger than the mobile breakpoint. If the sidebar is open and the window is
  * larger than mobile, then the menu is toggled closed automatically. This
  * will remove any side effects that are added to the sidebar context that
  * prevents background scrolling while the sidebar is open.
  */
  checkVisibility() {
    if (!this.state.open) {
      return
    }

    // TODO: Global js breakpoint variables?
    if (window.innerWidth >= 768) {
      this.toggleMenu('Resize')
    }
  }

  render() {
    let customStyles = {}

    if (this.props.data.useCustomTheme && this.props.data.useCustomTheme === 'yes') {
      customStyles = {
        backgroundColor: this.props.data.backgroundColor,
        backgroundImage: this.props.data.backgroundImage,
        textColor: this.props.data.textColor,
      }
    }

    return (
      <span>
        <MobileMenuButton onClick={this.toggleMenu} />
        <MobileSidebar
          isOpen={this.state.open}
          toggleSidebar={this.toggleMenu}
          side="left"
        >
          <MobileMenuContent 
            content={this.props.data.content} 
            settings={customStyles}
            toggleSidebar={this.toggleMenu}
          />
        </MobileSidebar>
      </span>
    )
  }
}

MobileMenu.propTypes = {
  data: PropTypes.object.isRequired,
}

export default MobileMenu
